import React from "react";
import { connect } from "react-redux";

class PumpDS extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="container">
                <div className="row">
                  <div className="col">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      data-keyboard="true"
                      aria-label="Close"
                    >
                      <span>Close</span>
                    </button>
                    <h4 className="modal-title" id="pageModalLabel">
                      Pump Data Sheet
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-body">
              <div className="container">
                <div className="row">
                  <div className="col">
                    <div className="dialog">
                      <div className="dialog-body">
                        <h5>
                          <i
                            className="fa fa-exclamation-triangle"
                            aria-hidden="true"
                          ></i>
                          This will be a Pump Data Sheet
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect()(PumpDS);
